
export default {
    baseApi:process.env.VUE_APP_URL,
    // baseApi: "/api",
    token:process.env.VUE_APP_TOKEN,
    supplier_url: 'https://supplier.v2.xinghaohuo.com/'
}